{
  "actions": {
    "newJob": "New service job",
    "approveFollowUp": "Approve follow-up",
    "recordAnswer": "Record the customer’s answer",
    "invoice": "Invoice completed work",
    "collect": "Record payment",
    "schedule": "Schedule visit",
    "scheduleAnother": "Schedule another visit",
    "recordAgreement": "Record price approval",
    "openVisit": "Open visit {{label}}",
    "edit": "Edit details",
    "waiting": "Waiting for…",
    "history": "History",
    "cancel": "Cancel job",
    "scheduleNextPart": "Schedule next part",
    "repeat": "Repeat job"
  },
  "toast": {
    "created": "Job {{number}} opened",
    "updated": "Job {{number}} updated"
  },
  "register": {
    "title": "Service jobs",
    "views": "Job views",
    "view": {
      "open": "Open",
      "awaiting": "Awaiting a visit",
      "scheduled": "Scheduled",
      "unfinished": "Unfinished",
      "ready": "Ready to invoice",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "all": "All"
    },
    "searchPlaceholder": "Search job, customer, location or problem…",
    "searchLabel": "Search jobs",
    "clearSearch": "Clear search",
    "tableLabel": "Service jobs",
    "clearFilters": "Clear filters",
    "forCustomer": "Jobs of {{name}}",
    "notScheduled": "Not scheduled",
    "missed": "Missed",
    "filters": {
      "customer": "Customer",
      "anyCustomer": "Any customer",
      "team": "Team",
      "allTeams": "All teams",
      "work": "Work",
      "anyWork": "Any work status",
      "billing": "Billing",
      "anyBilling": "Any billing",
      "payment": "Payment",
      "anyPayment": "Any payment",
      "priority": "Priority",
      "anyPriority": "Any priority",
      "attention": "Needs attention",
      "anyAttention": "Any flag",
      "overdue": "Overdue",
      "waitingParts": "Waiting for parts",
      "waitingCustomer": "Waiting for the customer",
      "followUpPending": "Follow-up requested",
      "collectionsAwaiting": "Payments to verify",
      "billingMode": "Billing type",
      "anyBillingMode": "Any billing type",
      "toggle": "Filters",
      "more": "More filters",
      "origin": "Kind of job",
      "anyOrigin": "Requests and planned"
    },
    "empty": {
      "title": "No service jobs yet",
      "body": "Open a job when a customer calls with a problem.",
      "filteredTitle": "No jobs match these filters",
      "filteredBody": "Change the search or the filters to see more jobs.",
      "view": "No jobs in this view."
    },
    "filtersCount_one": "Filters, {{n}} set",
    "filtersCount_other": "Filters, {{n}} set",
    "moreFiltersCount_one": "More filters, {{n}} set",
    "moreFiltersCount_other": "More filters, {{n}} set"
  },
  "columns": {
    "number": "Job",
    "issue": "Problem",
    "planned": "Planned visit",
    "customer": "Customer and location",
    "nextVisit": "Next visit",
    "status": "Status",
    "priority": "Priority",
    "targetDate": "Complete by",
    "createdAt": "Opened"
  },
  "form": {
    "newTitle": "New service job",
    "newDescription": "Who called, where, and what’s wrong.",
    "editTitle": "Edit {{number}}",
    "sections": {
      "where": "Customer and location"
    },
    "q": {
      "where": "Where",
      "whereFirst": "Choose the customer first.",
      "problem": "What’s wrong",
      "when": "When would they like us"
    },
    "when": {
      "any": "Any time",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "pick": "Pick a day",
      "part": "Time of day",
      "anyPart": "Any time of day"
    },
    "facts": {
      "change": "Change",
      "changeContact": "Change the on-site contact",
      "add": "Add",
      "addContact": "Add an on-site contact",
      "noContact": "No on-site contact yet",
      "assets": "Unit or equipment (optional)"
    },
    "chooseSite": "Choose a location",
    "searchSites": "Search by name, code or address",
    "noSiteMatch": "No location matches.",
    "newSiteTyped": "New location “{{name}}”",
    "openHere": {
      "title_one": "{{n}} open job at {{site}}",
      "title_other": "{{n}} open jobs at {{site}}",
      "titleOther_one": "{{n}} other open job at {{site}}",
      "titleOther_other": "{{n}} other open jobs at {{site}}",
      "seeAll": "All of the customer’s open jobs",
      "failed": "Could not check this location for open jobs.",
      "here_one": "{{n}} open job here",
      "here_other": "{{n}} open jobs here",
      "hereOther_one": "{{n}} other open job here",
      "hereOther_other": "{{n}} other open jobs here",
      "view": "View",
      "hide": "Hide"
    },
    "newSite": "New location",
    "newSiteBody": "Enter the address where the work is.",
    "noSitesYet": "This customer has no service location yet: enter the first one.",
    "siteNamePlaceholder": "Villa 12, Al Khuwair",
    "directionsPlaceholder": "Landmarks, gate, floor…",
    "mapUrlHint": "A link from your maps app, starting with https://",
    "contactHint": "Taken from the location; change it for this job only.",
    "issuePlaceholder": "What the customer reported, in their words",
    "requestedServicePlaceholder": "e.g. AC maintenance",
    "targetDateHint": "Past this date, an unfinished job is overdue.",
    "teamHint": "The team that owns the job; each visit names its own.",
    "noTeam": "No team yet",
    "chargeableBody": "The customer pays for the work: agreed prices, then an invoice.",
    "contractBody": "Covered by a service contract: a visit report, no visit invoice.",
    "notesHint": "Shown at the top of the job, for everyone who works on it.",
    "create": "Create job",
    "saveWithoutBooking": "Save without booking",
    "bookVisit": "Book a visit",
    "save": "Save changes",
    "errors": {
      "customer": "Choose the customer.",
      "site": "Choose a service location or enter a new one.",
      "issue": "Describe the problem.",
      "siteName": "Name the location.",
      "siteAddress": "Enter the address.",
      "mapUrl": "Use a link starting with https://",
      "date": "Enter a valid date."
    },
    "sitesFailed": "The customer’s service locations could not be loaded. Try again before adding a new one.",
    "more": "More details",
    "moreHint": "Team, complete-by date, service requested, billing, notes",
    "salesperson": "Salesperson",
    "salespersonHint": "Who sold the job: its invoices credit them.",
    "salespersonDefault": "The customer’s salesperson",
    "booked": "Visit booked: {{team}}, {{date}}",
    "bookedChange": "Change",
    "bookFailed": "The job is saved. Book its visit here."
  },
  "job": {
    "title": "Service job",
    "backToRegister": "Back to service jobs",
    "request": "The request",
    "noContact": "No contact recorded.",
    "openMap": "Open map",
    "call": "Call",
    "openedBy": "{{date}} by {{name}}",
    "cancelledTitle": "Cancelled on {{date}}",
    "reasons": {
      "closed": "The job is closed.",
      "followUpPending": "A follow-up request is waiting: approve or return it.",
      "followUpRequired": "The job was already visited: the next visit comes from an approved follow-up request."
    },
    "cancel": {
      "title": "Cancel {{number}}?",
      "description": "Its scheduled visits are cancelled too. The job stays in the register as cancelled.",
      "reason": "Reason",
      "reasonRequired": "Say why the job is cancelled.",
      "confirm": "Cancel job",
      "toast": "Job {{number}} cancelled"
    },
    "waiting": {
      "title": "{{number}} is waiting for…",
      "description": "The job shows what it is waiting for until the next visit starts.",
      "label": "Waiting for",
      "partsBody": "Parts are ordered or on their way.",
      "customerBody": "The customer has to confirm, pay or give access.",
      "clear": "Not waiting",
      "clearBody": "Clears the indicator.",
      "cleared": "No longer waiting",
      "note": "Note",
      "confirm": "Save"
    }
  },
  "next": {
    "title": "Next step",
    "followUp": "{{name}} asks for another visit: {{reason}}.",
    "followUpWaiting": "{{name}} asked for another visit ({{reason}}). It waits for a manager’s approval.",
    "answer": "The price was sent to the customer. Record their answer.",
    "answerWaiting": "The price was sent to the customer, who has not answered yet.",
    "price": "Price",
    "onSite": "{{team}} is on site now.",
    "invoice": "Finished work is ready to invoice.",
    "toInvoice": "To invoice",
    "collect": "Invoiced. Record the payment when the customer pays.",
    "toPay": "Still to pay",
    "visit": "The team visits on {{date}}.",
    "visitMissed": "The visit on {{date}} was missed. Book it again.",
    "visitMissedWaiting": "The visit on {{date}} was missed.",
    "schedule": "No visit is booked yet.",
    "scheduleAgain": "The last visit left work to do. Book the next visit.",
    "scheduleWaiting": "No visit is booked yet. The coordinator books one.",
    "followUpNeeded": "The last visit left work to do. The team asks for the next visit from that visit’s page.",
    "invoiceWaiting": "The work is done and waits to be invoiced.",
    "paymentWaiting": "Invoiced. Waiting for the customer to pay.",
    "verify_one": "The team reported a payment. Verify it.",
    "verify_other": "The team reported {{n}} payments. Verify them.",
    "reported": "Awaiting verification",
    "verifyOne": "Verify payment",
    "verifyQueue": "Verify payments",
    "verifyWaiting": "The customer paid the team. The payment waits for the accountant to verify it.",
    "done": "Nothing left to do: the work is done.",
    "donePaid": "Nothing left to do: the work is done, invoiced and paid.",
    "doneContract": "Nothing left to do: the work is done under the contract."
  },
  "sections": {
    "label": "Job sections",
    "scope": "Items",
    "visits": "Visits",
    "money": "Money",
    "files": "Files"
  },
  "scope": {
    "title": "Items",
    "add": "Add item",
    "actions": "Item actions",
    "editItem": "Edit {{item}}",
    "removeItem": "Remove {{item}}",
    "cannotRemove": "Work is done or invoiced: it cannot be removed",
    "covered": "Covered",
    "needsAgreement": "Price not agreed",
    "progressHead": "Progress",
    "progress": "{{done}} of {{quantity}} done",
    "invoicedQty": "{{n}} invoiced",
    "chargeableTotal": "Chargeable total (VAT included)",
    "contractNote": "Items are covered by the contract unless marked chargeable (extra work).",
    "changedNote": "Items changed since the customer agreed: record a new price approval before the work.",
    "declinedNote": "The customer declined the price. Change the items or record a new approval.",
    "emptyTitle": "No items yet",
    "emptyBody": "Add the services and parts this job needs, then record the customer’s price approval.",
    "removeTitle": "Remove “{{item}}”?",
    "removeBody": "The item leaves the job’s scope.",
    "removeAgreedBody": "The item was agreed with the customer: the job needs a new price approval.",
    "remove": "Remove item",
    "toast": {
      "removed": "Item removed"
    }
  },
  "agreements": {
    "version": "v{{n}}",
    "history_one": "Price approval history ({{n}})",
    "history_other": "Price approval history ({{n}})",
    "recordedBy": "Recorded by {{name}}, {{date}}",
    "lines_one": "{{n}} item",
    "lines_other": "{{n}} items"
  },
  "agreement": {
    "title": "Record price approval",
    "description": "The chargeable items and the total, as the customer sees them.",
    "answerTitle": "The customer’s answer to v{{n}}",
    "answerDescription": "The items and total that were sent to the customer.",
    "shown": "What the customer is agreeing to",
    "nothing": "There are no chargeable items to agree.",
    "total": "Total",
    "vatIncluded": "Totals include VAT.",
    "decisionLabel": "The customer’s answer",
    "decision": {
      "ACCEPTED": "Accepted",
      "DECLINED": "Declined",
      "AWAITING": "Sent, awaiting answer",
      "acceptedBody": "The team may do the work at these prices.",
      "declinedBody": "No work at these prices.",
      "awaitingBody": "The price was sent; record the answer later."
    },
    "submit": {
      "ACCEPTED": "Record acceptance",
      "DECLINED": "Record decline",
      "AWAITING": "Record as sent"
    },
    "errors": {
      "approverName": "Who agreed (or declined) for the customer?"
    },
    "scopeChangedTitle": "The items changed",
    "scopeChangedBody": "Someone changed the items since this was opened. The list above is now current: check it with the customer, then record again.",
    "evidenceHint": "After recording, you can attach the signed estimate or a screenshot of the message.",
    "evidenceTitle": "Price approval v{{n}} recorded",
    "evidenceDescription": "Attach the evidence: the signed estimate, a photo or a screenshot of the message.",
    "version": "Price approval v{{n}}",
    "recorded": {
      "ACCEPTED": "v{{n}} accepted by the customer.",
      "DECLINED": "v{{n}} declined by the customer.",
      "AWAITING": "v{{n}} sent: awaiting the customer’s answer.",
      "SUPERSEDED": "v{{n}} recorded."
    },
    "addEvidence": "Add evidence",
    "done": "Done",
    "toast": {
      "accepted": "Price approval v{{n}} recorded",
      "declined": "Declined price v{{n}} recorded",
      "sent": "Price v{{n}} recorded as sent"
    }
  },
  "item": {
    "addTitle": "Add item",
    "editTitle": "Edit item",
    "description": "A service or part from the catalogue, or free text.",
    "contractDescription": "The contract terms decide whether it is covered or billed, unless you set it here.",
    "source": "Where the item comes from",
    "catalogue": "From the catalogue",
    "catalogueBody": "A service or part with its price.",
    "freeText": "Free text",
    "freeTextBody": "Describe it and set the price.",
    "product": "Service or part",
    "productPlaceholder": "Search name, SKU or barcode",
    "descriptionOverride": "Description (optional)",
    "descriptionPlaceholder": "e.g. Replace compressor capacitor",
    "noTax": "No VAT",
    "priceLocked": "Part of it is invoiced: the price stays as invoiced.",
    "chargeableHint": "The customer pays for it.",
    "coveredHint": "Covered: never invoiced.",
    "agreedWarning": "This item was agreed in v{{n}}: changing it needs a new price approval.",
    "net": "Before VAT",
    "add": "Add item",
    "save": "Save item",
    "errors": {
      "product": "Choose a service or part, or switch to free text.",
      "description": "Describe the item.",
      "quantity": "Enter a quantity above zero.",
      "price": "Enter the price (zero or more)."
    },
    "toast": {
      "added": "Item added",
      "updated": "Item updated"
    },
    "byTerms": "Decided by the contract terms (labour, parts and consumables as the contract says).",
    "useTerms": "Leave it to the contract terms"
  },
  "visits": {
    "title": "Visits",
    "emptyTitle": "No visits yet",
    "emptyBody": "Book a team at a time that suits the customer.",
    "lead": "Lead: {{name}}",
    "rescheduled_one": "Rescheduled once",
    "rescheduled_other": "Rescheduled {{n}} times",
    "reschedule": "Reschedule",
    "cancel": "Cancel visit",
    "cancelTitle": "Cancel visit {{label}}?",
    "cancelTitleShort": "Cancel visit?",
    "cancelDescription": "The team and the visit lead are told. The reason stays in the history.",
    "cancelReason": "Reason",
    "cancelReasonRequired": "Say why the visit is cancelled.",
    "cancelConfirm": "Cancel visit",
    "toast": {
      "cancelled": "Visit {{label}} cancelled"
    },
    "covers": "Covers",
    "wholeJob": "Covers the whole job",
    "morePlaces_one": "and {{n}} more",
    "morePlaces_other": "and {{n}} more",
    "places_one": "{{n}} place",
    "places_other": "{{n}} places",
    "noLead": "No lead yet",
    "cancelReasons": {
      "CUSTOMER": "Customer cancelled",
      "DUPLICATE": "Booked twice",
      "TEAM": "Team not available",
      "OTHER": "Other"
    },
    "cancelSentence": {
      "CUSTOMER": "The customer cancelled the visit.",
      "DUPLICATE": "The visit was booked twice.",
      "TEAM": "The team is not available."
    },
    "cancelReasonOptional": "Reason (optional)"
  },
  "followUps": {
    "title": "Follow-up requests",
    "after": "after visit {{label}}",
    "requestedBy": "Requested by {{name}}, {{date}}",
    "decidedBy": "decided by {{name}}, {{date}}",
    "approve": "Approve and schedule",
    "return": "Return",
    "resubmit": "Edit and resubmit",
    "withdraw": "Withdraw",
    "openVisit": "Open the follow-up visit",
    "returnTitle": "Return the follow-up request · {{number}}",
    "returnDescription": "{{name}} sees your note and can change the request or withdraw it.",
    "returnNote": "What should change",
    "returnNoteHint": "e.g. Bring the parts list, or propose another date.",
    "returnNoteRequired": "Write a note for the requester.",
    "withdrawTitle": "Withdraw the follow-up request?",
    "withdrawBody": "No follow-up visit will be scheduled from it.",
    "toast": {
      "returned": "Request returned to {{name}}",
      "withdrawn": "Request withdrawn"
    }
  },
  "schedule": {
    "title": "Schedule a visit · {{number}}",
    "description": "Choose the team, the visit lead, the day and the time window.",
    "rescheduleTitle": "Reschedule visit {{label}}",
    "rescheduleTitleShort": "Reschedule visit",
    "rescheduleDescription": "Before the team arrives, the date, window, team and lead can change. The old values stay in the history.",
    "approveTitle": "Approve the follow-up · {{number}}",
    "approveDescription": "Schedules the follow-up visit. Change the date, window, team or lead if needed.",
    "chooseTeam": "Choose a team",
    "chooseLead": "Choose the visit lead",
    "teamFirst": "Choose a team first",
    "noMembers": "This team has no active members.",
    "leadRole": "Lead",
    "noDuration": "Not set",
    "hours_one": "{{n}} hour",
    "hours_other": "{{n}} hours",
    "workHours_one": "About {{n}} hour of work",
    "workHours_other": "About {{n}} hours of work",
    "windowHint": "Leave empty for any time of the day.",
    "prefers": "Customer’s preference: {{part}}. Leave empty for any time.",
    "notes": "Notes for the team",
    "reason": "Reason for the change",
    "reasonHint": "e.g. Customer asked for the afternoon.",
    "reasonOptional": "Reason for the change (optional)",
    "approveNote": "Note to the requester",
    "availability": "That day",
    "availabilityOn": "{{date}}",
    "availabilityHint": "Choose a team and a date to see their other visits.",
    "availabilityFailed": "The other visits could not be loaded.",
    "retry": "Try again",
    "teamDay": "{{team}}",
    "leadDay": "{{name}}’s other visits",
    "free": "No other visits.",
    "overlaps": "Overlaps",
    "overlapTitle": "The team or the visit lead is busy then",
    "overlapBody": "This window overlaps:",
    "anyway": "Schedule anyway",
    "submit": "Schedule visit",
    "submitReschedule": "Reschedule visit",
    "submitApprove": "Approve and schedule",
    "errors": {
      "team": "Choose a team.",
      "lead": "Choose the visit lead.",
      "date": "Choose the date.",
      "window": "The end is before the start.",
      "reason": "Say why the visit moves."
    },
    "toast": {
      "scheduled": "Visit {{label}} scheduled",
      "rescheduled": "Visit {{label}} rescheduled",
      "approved": "Follow-up approved and scheduled · {{number}}"
    },
    "covers": {
      "title": "This visit covers",
      "wholeAction": "The whole job",
      "busy": "In {{visit}} on {{date}}",
      "extra": "Also covers:",
      "whole_one": "The whole job · {{n}} asset",
      "whole_other": "The whole job · {{n}} assets",
      "chosen_one": "{{n}} place · {{assets}} assets",
      "chosen_other": "{{n}} places · {{assets}} assets",
      "free_one": "Choose the place not in a visit yet",
      "free_other": "Choose the {{n}} places not in a visit yet",
      "assets_one": "{{n}} asset",
      "assets_other": "{{n}} assets",
      "checked": "{{checked}}/{{total}} checked",
      "onSite_one": "{{n}} asset on the site itself is covered only by a visit for the whole job.",
      "onSite_other": "{{n}} assets on the site itself are covered only by a visit for the whole job.",
      "hint": "Tick the places this visit covers; none ticked is the whole job."
    },
    "leadOptional": "Visit lead (optional)",
    "anyMember": "Anyone on the team",
    "anyMemberHint": "Whoever starts the visit becomes its lead.",
    "reasonWhen": "Needed when the day or the team changes.",
    "adjustHint": "Same day, same team: a small change, not counted as a reschedule."
  },
  "money": {
    "figures": "The job’s money",
    "scope": "Job total",
    "agreed": "Agreed",
    "completed": "Work done",
    "invoiced": "Invoiced",
    "paid": "Paid",
    "balance": "Balance due",
    "reported": "Awaiting verification",
    "invoices": "Invoices",
    "collections": "Payments collected",
    "status": "Status",
    "draft": "Draft",
    "invoiceStatus": {
      "DRAFT": "Draft",
      "POSTED": "Posted",
      "VOID": "Void"
    },
    "contractNote": "Under contract: visits are not invoiced; only extra chargeable items are.",
    "nothingToInvoice": "Nothing completed is waiting to be invoiced.",
    "noInvoices": "No invoices yet. Invoice the work once it is completed.",
    "none": "No invoices.",
    "noCollections": "No payments collected.",
    "noCollectionsYet": "No payments collected yet. Record what the customer paid the team.",
    "collectedBy": "Collected by {{name}}, {{date}}",
    "verify": "Verify"
  },
  "customer": {
    "repeatJob": "Repeat job {{number}}",
    "tab": "Service",
    "jobs": "Service jobs",
    "openOf": "{{open}} open of {{total}}",
    "allJobs": "All jobs",
    "newJob": "New service job",
    "newJobHere": "New job here",
    "newJobAt": "New job here, at {{site}}",
    "noJobs": "No service jobs for this customer yet",
    "noJobsBody": "Open a job when the customer reports a problem.",
    "nextVisit": "Next visit",
    "opened": "Opened {{date}}"
  },
  "sites": {
    "title": "Service locations",
    "add": "Add location",
    "addTitle": "New service location",
    "editTitle": "Edit service location",
    "addSubmit": "Add location",
    "save": "Save location",
    "edit": "Edit {{name}}",
    "archive": "Archive {{name}}",
    "restore": "Restore {{name}}",
    "archived": "Archived",
    "showArchived": "Show archived",
    "hideArchived": "Hide archived",
    "noArchived": "No archived locations.",
    "empty": "No service locations yet",
    "emptyBody": "Add the places where the team works for this customer.",
    "archiveTitle": "Archive {{name}}?",
    "archiveBody": "New jobs can no longer use it. Its jobs keep it.",
    "archiveConfirm": "Archive location",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "New jobs can use it again.",
    "restoreConfirm": "Restore location",
    "toast": {
      "added": "Location {{name}} added",
      "updated": "Location {{name}} updated",
      "archived": "Location {{name}} archived",
      "restored": "Location {{name}} restored"
    }
  },
  "planned": {
    "due": "Due {{date}}",
    "checked": "{{checked}} of {{total}} assets checked"
  },
  "usual": {
    "title": "Usual items",
    "hint": "One tap adds it: quantity 1, at the price shown.",
    "add": "Add {{item}} at {{price}}",
    "added": "{{item}} added",
    "undo": "Undo",
    "removed": "{{item}} removed",
    "source": {
      "SITE": "Used at this location",
      "CUSTOMER": "Used for this customer",
      "COMPANY": "Often used"
    }
  }
}
